import { Routes } from '@angular/router';
import { HomeComponent } from './routes/home/home.component';
import { LoginComponent } from './routes/auth/login/login.component';
import { RegisterComponent } from './routes/auth/register/register.component';
import { SubscriptionConfirmationComponent } from './routes/subscription-confirmation/subscription-confirmation.component';
import { authGuard, unauthGuard } from './guards/auth.guard';
import { SubscriptionUpdateComponent } from './routes/subscription/subscription/subscription-update.component';
import { subscriptionGuard } from './guards/subscription.guard';
import { ForgotPasswordComponent } from './routes/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './routes/auth/reset-password/reset-password.component';
import { ProfileManagementComponent } from './routes/profile-management/profile-management.component';
import { RedirectComponent } from './routes/redirect/redirect.component';
import { RedirectRouteData } from './models/redirect-route-data';
import { DashboardComponent } from './routes/admin/dashboard/dashboard.component';
import { adminGuard } from './guards/admin.guard';
import { UserDetailComponent } from './routes/admin/user-detail/user-detail.component';
import { AdminComponent } from './routes/admin/admin.component';

export const routes: Routes = [
  { path: '', title: 'GT Pro Tune', component: HomeComponent, canActivate: [authGuard] },
  { path: 'login', component: LoginComponent, canActivate: [unauthGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [unauthGuard] },
  { path: 'subscription-confirmation', component: SubscriptionConfirmationComponent, canActivate: [authGuard] },
  { path: 'subscription', component: SubscriptionUpdateComponent, canActivate: [authGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [unauthGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [unauthGuard] },
  { path: 'profile', component: ProfileManagementComponent, canActivate: [authGuard] },
  {
    path: 'admin', component: AdminComponent, canActivate: [authGuard, adminGuard], children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'user-detail', component: UserDetailComponent, canActivate: [authGuard, adminGuard] },
      { path: '', component: DashboardComponent }
    ]
  },
  { path: 'a/downloads/-/f0f4f72b7747bf78/b53666638471719f', component: RedirectComponent, data: { redirectTo: 'https://gtplanet.com' } as RedirectRouteData },
  { path: '**', redirectTo: '' }
];
